import { environment } from '../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UsersService = /** @class */ (function () {
    function UsersService(http) {
        this.http = http;
    }
    UsersService.prototype.errorHandler = function (err) {
        if (err.error && err.error.message) {
            alert(err.error.message);
        }
        else {
            alert('Feil på url: ' + err.url + '\n Status code: ' + err.status + '\n' + err.message);
        }
        return throwError(err);
    };
    UsersService.prototype.getUsers = function () {
        return this.http.get(environment.BACKEND_SERVER_URL + '/systemuser', { withCredentials: true });
    };
    UsersService.prototype.saveUserData = function (userId, userData) {
        return this.http.post(environment.BACKEND_SERVER_URL + '/systemuser/' + userId, userData, { withCredentials: true });
    };
    UsersService.prototype.createNewUser = function (userData) {
        return this.http.post(environment.BACKEND_SERVER_URL + '/systemuser', userData, { withCredentials: true })
            .pipe(catchError(this.errorHandler));
    };
    UsersService.prototype.deleteUser = function (userId) {
        return this.http.delete(environment.BACKEND_SERVER_URL + '/systemuser/' + userId, { withCredentials: true });
    };
    UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.HttpClient)); }, token: UsersService, providedIn: "root" });
    return UsersService;
}());
export { UsersService };
